<template>
    <div class="page wallet" style="background-color:white; min-height: 15rem">
        <div class="title">
            <mu-appbar class="center">
                <mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goback" />
                <!--<router-link slot="left" to="/search/homeList"><mu-icon value="keyboard_arrow_left" color="white"/></router-link>-->
                <span class="topT left">填写订单</span>
            </mu-appbar>
        </div>
        <div v-if='!loginState' style="display:flex;padding:14px;color:#FF9347;font-size:0.28rem;background-color:#fff3ea;border-bottom:1px solid #ffdac4;position:relative">
            <div style="margin:0">登录后预订可享受更多优惠
                <!--<a href='#/user/Login' style="font-size:0.32rem;color:#FF9347;position:absolute;right:0.4rem;top:0.25rem">立即登录</a>-->
                <span style="font-size:0.32rem;color:#FF9347;position:absolute;right:0.4rem;top:0.25rem" v-on:click="gologin">立即登录</span>

            </div>
        </div>
        <div class="top">
            <h3>{{g_currentInfo.HotelName}}</h3>
            <mu-divider/>
        </div>
        <div style=" overflow:hidden ; line-height: 1rem ;">
            <!--<mu-date-picker v-model="g_searchParam.startDate" hintText="入住日期" icon="date_range" disabled :underlineShow="false"
                                                             style=" float:left ; padding:0.2rem 0 0rem      ;  ; width: 3rem  ;  height:1rem  " id="LiveDate" />-->
            <!--<mu-dropDown-menu :value="relaxHour" @change="setRelaxHour" icon="search" style="float:right ;  margin-top:0.07rem ">-->

            <!--<span style="  padding: 0.35rem 0rem 0 0.3rem ; font-size:0.30rem ; font-weight: 600; color:#333  ">-->
            <span style=" float:left ; margin-left:0.3rem  ;  font-size:0.30rem ; font-weight: 600; color:#333 ">
                入住时间
            </span>

            <mu-dropDown-menu :value="relaxHour" @change="setRelaxHour" icon="search" id="LiveDate2" style="  float: left ;  margin-top: 0 ; margin-bottom: 0 ; margin-left:0.3rem ; font-size:0.3rem ;  ">
                <mu-menu-item :value="item" :title="item+':00'" v-for="  item in HourList" />
            </mu-dropDown-menu>

            <span style=';width:1rem;font-size:0.28rem;'>{{arriveDateFormat}}&nbsp;({{ relaxHourEND }}:00离店)</span>
        </div>
        <div style="height:0.1rem"></div>

        <div class="greyBlock" style="margin-top:-0.2rem"></div>
        <div class="main" style="min-height: 13rem ">
                <div class="room">
                    <label>房型名称</label>
                    <span>{{g_currentRoom.RoomTypeName}}</span>
                </div>
                <mu-divider/>
                <div class="room">
                    <label>房间数</label>
                    <span>
                        1 间
                    </span>
                </div>
                <mu-divider/>
                <div class="room">
                    <label>入住人</label>
                    <input v-if='loginState' v-model="cusName" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 3rem" placeholder="请输入姓名" />
                    <input v-else v-model="cusName" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 3rem" placeholder="请输入姓名" />
                    <!--<mu-text-field v-if='loginState' v-model='cusName' class="demo-divider-form" :underlineShow="false" disabled/>-->
                    <!--<mu-text-field v-else v-model='cusName' class="demo-divider-form" :underlineShow="false" />-->
                </div>
                <mu-divider/>
                <div class="room">
                    <label>手机</label>
                    <input v-model="phoneNum" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 3rem" placeholder="请输入手机号" />

                </div>
                <!--<mu-divider/>-->
                <!--<div class="room">
                                    <label>邮箱</label>
                                    <mu-text-field v-model='mail' class="demo-divider-form" :underlineShow="false" />
                                </div>-->
                <mu-divider v-if='!loginState' />
                <div class="room" v-if='!loginState'>
                    <label>图像验证码</label>
                    <!--<mu-text-field v-model='imgCode' hintText="此处填写图像验证码" class="demo-divider-form" style=" width: 3.2rem" :underlineShow="false" />-->
                    <input v-model="imgCode" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 3rem" placeholder="请输入图像验证码" />

                    <img v-bind:src="TPFJM" style="width: 1.5rem;margin:auto;" v-on:click="getValidateCode" align="right" />
                </div>
                <mu-divider v-if='!loginState' />
                <div class="room" v-if='!loginState'>
                    <label>验证码</label>
                    <input v-model="FJM" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 3rem" placeholder="请输入验证码" />
                    <!--<mu-text-field v-model='FJM' hintText="手机/邮箱验证码" class="demo-divider-form" style=" width: 3.7rem" :underlineShow="false" />-->
                    <a v-show="haveYZM == false" @click='noLoginValid' style="padding:0;width: 1.5rem;height:35px; ; text-align:center;display:inline-block;line-height:35px;margin:auto ;color:white;background-color:#27ba69">获取</a>
                    <a v-show="haveYZM == true" style="padding:0;width: 1.5rem;height:35px;; text-align:center;display:inline-block;line-height:35px;margin:auto ;color:#999;background-color:#eeeeee  ">{{WaitTime}}</a>
                </div>
                <mu-divider/>
                <div class="room">
                    <label>特殊要求</label>
                    <input v-model="requires" style=" color:#666 ; border:0 ; outline:0 ; font-size:0.28rem ; width: 4.5rem" placeholder="请输入您的特殊要求" />
                    <!--<mu-text-field v-model='requires' hintText="请在此处填写您的特殊要求" class="demo-divider-form" :underlineShow="false" />-->
                </div>
                <mu-divider/>

                <div class='room'>
                    <label>需要发票</label>
                    <mu-switch v-model='hasInvo' style="width:80px;margin:auto 0px;" @change="changeInvo" />
                </div>

      <div class="couponList">
        <p v-if="loginState">
          <label>优惠券</label>
        </p>
             
        <div class="coupons" v-if="loginState">
          <div
            class="coupon" style="width: 136px;"
            v-if="vochers != '' && vochers != null"
            v-bind:class="{ active: useState.useVocher }"
            @click="focus(1)"
          >
            <div>
              <h3>代金券</h3>

            <mu-dropDown-menu   v-if="voState"
                    :value="vocher"
                    @change="changeVocher" 
                    icon="search"
                    id="LiveDate3"
                    labelClass="vocherList"
                    :autoWidth="true"
                    style="float: left ;  margin-top: 0 ; margin-bottom: 0 ; margin-left:0.1rem ; font-size:0.25rem ;  ">
                    
                <mu-menu-item value="0" title="不抵扣"/>
                <mu-menu-item
                  :value="voc"
                  :title="'抵'+ voc+'小时'"
                  v-for="voc in vochers"
                  v-if="userVochers['v' + voc] != ''"
                />
            </mu-dropDown-menu>

             <!-- <mu-dropDown-menu
                v-if="voState"
                :value="vocher"
                @change="changeVocher"
                labelClass="vocherList"
                :autoWidth="true"
               icon="search" id="LiveDate2" style="  float: left ;  margin-top: 0 ; margin-bottom: 0 ; margin-left:0.3rem ; font-size:0.3rem ;  "
              >
                <mu-menu-item value="0" title="不抵扣"/>
                <mu-menu-item
                  :value="voc"
                  :title="'抵'+ voc+'小时'"
                  v-for="voc in vochers"
                  v-if="userVochers['v' + voc] != ''"
                />
              </mu-dropDown-menu> -->
          
             
            </div>

          </div>
        </div>
      </div>
      <div style="margin-left:0.3rem " v-if="g_currentRoom.RoomType==102 || g_currentRoom.RoomType==103"  > 
        <div> <h3>活动说明</h3></div>
            <span>{{g_currentRoom.ActivityComment}}</span>
       </div>

                <mu-list-item v-if='hasInvo' :title="invoiceInfo.InvoiceType+ ' ' + invoiceInfo.InvoiceProperty+ ' ' + invoiceInfo.Name" v-on:click="changeInvo(true)" style="width:90%;padding:0px;background-color:#FCFCFC;margin:0 auto;margin-bottom:15px;" titleClass="invoice">
                    <mu-icon slot="right" value="keyboard_arrow_right" />
                </mu-list-item>
            <div class="check">
                <label>订单金额：</label>&nbsp;
                <span class="money" v-if='!loginState'>
                    <span class="small">￥</span>{{ g_currentRoom.NotMemberPrice | fomatFloat }}&nbsp;元
                </span>
                <span class="money" v-if='loginState'>
                    <span class="small">￥</span>{{ g_currentRoom.MemberPrice | fomatFloat }}&nbsp;元
                </span>
                <!--<span class="money"  >
                                                                        <span class="small" >￥</span>{{ g_currentRoom.bookPrice | fomatFloat }}&nbsp;元
                                                                    </span>-->
                <!--<span class="see" @click="openDetail">查看明细&nbsp;></span>-->
                <a @click="SubmitRelaxHotelOrder">
                    <span style="  ">提交订单</span>
                </a>
            </div>
        </div>

        <mu-dialog :open="invoice" dialogClass='invoiceDia'>
            <mu-tabs :value="activeTab" @change="handleTabChange" style='background-color:white;' class='invoiceTab'>
                <mu-tab value="tab1" title="增值税普通发票" />
                <mu-tab value="tab2" title="增值税专用发票" />
            </mu-tabs>
            <div v-if="activeTab === 'tab1'" style="padding:1em 0;text-align:center">
                <mu-radio label="个人发票" name="normal" nativeValue='person' v-model="normalType" v-on:click="setInvoiceInfo('tab1', 'person')" class="invoice-radio" />
                <mu-radio label="公司发票" name="normal" nativeValue='company' v-model="normalType" v-on:click="setInvoiceInfo('tab1', 'company')" class="invoice-radio" />
                <br/>
                <div style="text-align:left;padding-left:15px;margin-bottom:2rem">
                    <mu-text-field v-model='invoiceInfo.Name' label="抬头" hintText="请填写发票抬头" />
                    <br/>
                    <mu-text-field v-model='invoiceInfo.IndentityNo' label="税号" hintText="请填写税号" v-if='normalType == "company"' />
                    <br/>
                    <label style="color:#999999;font-size:0.22rem" v-if='normalType == "person"'>*个人普通发票仅需填写抬头</label>
                    <br/>
                    <label style="color:#999999;font-size:0.22rem" v-if='normalType == "company"'>*公司普通发票需填写抬头和税号</label>
                </div>
            </div>
            <div v-if="activeTab === 'tab2'" style="padding:1em 15px;overflow-y:scroll;max-height:9rem;overflow-x:hidden">
                <mu-text-field v-model='invoiceInfo.Name' label="抬头" hintText="请填写发票抬头" />
                <br/>
                <mu-text-field v-model='invoiceInfo.IndentityNo' label="税号" hintText="请填写税号" />
                <br/>
                <mu-text-field v-model='invoiceInfo.Phone' label="电话" hintText="请填写电话" />
                <br/>
                <mu-text-field v-model='invoiceInfo.Address' label="地址" hintText="请填写地址" />
                <br/>
                <mu-text-field v-model='invoiceInfo.BankName' label="开户行" hintText="请填写开户行" />
                <br/>
                <mu-text-field v-model='invoiceInfo.BankAccountNo' label="账号" hintText="请填写账号" />
                <br/>
                <label style="color:#999999;font-size:0.22rem">*填写增值税专用发票请务必保证信息正确完整</label>
                <br/>
            </div>
            <mu-raised-button label="确定" slot="actions" class="invoice-button" primary @click="saveInvoice" />
            <mu-raised-button label="取消" slot="actions" class="invoice-button" @click="closeInvoice" />
        </mu-dialog>
        <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
    </div>
</template>

<script>
import api from '../../api'
import { mapGetters, mapMutations } from 'vuex'
import date from '../../utils/dateextend.js'
export default {
    data() {
        return {

            //用户登录状态
            loginState: false,
            // 休闲房起始时间
            relaxHour: '',
            relaxHourEND: '',

            //  初始化页面
            cusName: '',
            phoneNum: '',
            mail: '',
            imgCode: '',
            FJM: '',
            requires: '',

            //发票对话框
            invoice: false,
            //当前发票
            activeTab: 'tab1',
            hasInvo: false,
            //发票信息
            invoiceInfo: {
                InvoiceType: '',
                Name: '',
                IndentityNo: '',
                Phone: '',
                Address: '',
                BankName: '',
                BankAccountNo: '',
                InvoiceProperty: ''
            },
            ownedInvoce: { special: '', person: '', company: '' },


            //个人发票or公司发票
            normalType: 'person',

            HourList: [],

            //验证码图像
            TPFJM: '',
            haveYZM: false,
            WaitTime: '',
            Time: 29,



            // 弹出提示
            toast: false,
        
           // 代金券选择状态
           useState: {
             useVocher: false,
           },
            //当前代金券抵扣额
            vocher: "0",
           // 酒店允许代金券
            vochers: [],
            TellUser: '',
             // 用户可用代金券
            userVochers: {
                v1: "",
                v2: "",
                v3: ""
            },

              //优惠券加载状态
            voucherState: false,
             //代金券加载状态
            voState: true,
            // 获取休闲房的金额
            finallymoney: 0,
        }
    },
    activated() {
        this.cusName = this.g_UserInfo.Name ? this.g_UserInfo.Name : ''
        this.phoneNum = this.g_UserInfo.sjno
        if (this.phoneNum == undefined) this.phoneNum = '';
        //获取验证码
        this.FJM = '';
        this.imgCode = '';
        this.getValidateCode()

        this.FirstInit();
 


        //获取登录状态
        var params = new this.URLSearchParam();
        params.append('cardNo', this.g_UserInfo.Card_no ? this.g_UserInfo.Card_no : '')
        this.$http.post(api.loginState(), params.toParam()).then((res) => {
            console.log("222"+res)
            console.log(res)
            if (res.Result) {
                this.loginState = true
            }
            else {
                //  登出按钮
                // this.$http.post(api.LogOff()).then((res) => { });
                this.$store.commit('CLEARUSER');
                this.loginState = false;

            }
        })

        // 初始化酒店休闲房的可入住的小时时刻

        var myDate = new Date();
        console.log(myDate.getHours());

        this.HourList = [];



        // this.relaxHour = parseInt(this.g_currentRoom.HourRoomStartTime).toString();

        this.relaxHour = parseInt(this.g_searchParam.relaxHour).toString();
        
        for (var i = parseInt(this.g_currentRoom.HourRoomStartTime); i <= this.g_currentRoom.HourRoomEndTime-1; i++) {
            this.HourList.push(i.toString());
        }

        this.relaxHourEND = (parseInt(this.relaxHour) + this.g_currentRoom.RoomHours).toString();
        
        this.initCoupon();

    },
    methods: {
        ...mapMutations([
            'setG_currentOrder',
            'setG_PayOrder',
            'setG_UserInfo',
            'setG_searchParam','setG_searchKeyWord'
        ]),

        FirstInit(){
            console.log( this.g_currentOrder.InvoiceNo  )

            if (this.g_currentOrder.InvoiceNo != '' && this.g_currentOrder.InvoiceNo != undefined) {

                // 获取到选中的发票信息了  让下面的按钮显示信息
                //初始化发票
                this.invoiceInfo = {
                    InvoiceType: '增值税普通发票',
                    Name: '',
                    IndentityNo: '',
                    Phone: '',
                    Address: '',
                    BankName: '',
                    BankAccountNo: '',
                    InvoiceProperty: ''
                }
                var params = new this.URLSearchParam();
                params.append('InvoiceId', this.g_currentOrder.InvoiceNo)
                this.$http.post(api.GetMyInvoice(), params.toParam()).then((res) => {

                    if (res.Result)
                        this.invoiceInfo = res.Data[0];
                });
            }
            else (
                this.hasInvo = false
            )

        },


        SubmitRelaxHotelOrder() {

            if (this.cusName == '') {
                this.TellUser = '请填写入住人姓名'
                this.showToast()
                return
            }
            if (this.phoneNum.length != 11) {
                this.TellUser = '请输入正确的手机号'
                this.showToast()
                return
            }

            var params = new this.URLSearchParam();
            params.append('payType', '3')
            params.append('cardNo', this.g_UserInfo.Card_no)
            params.append('resvName', this.cusName)
            params.append('resvMobile', this.phoneNum)

            params.append('hotelCode', this.g_currentRoom.hotelCode)
            params.append('roomId', this.g_currentRoom.RoomType)
            params.append('arriveDate', this.g_searchParam.arriveDate)

            params.append('Keysign', "hour")
            params.append('needSedSMS', !this.loginState)
            params.append('verifyCode', this.FJM)


            params.append('isneedInvoice', this.hasInvo)
            params.append('hourIn', this.relaxHour)

            params.append('note', this.requires)
            params.append("couponType", this.userVochers["v" + this.vocher]);

            if (this.hasInvo) {

                console.log(this.invoiceInfo)

                if (this.invoiceInfo.InvoiceType == "增值税普通发票") {
                    if (this.invoiceInfo.InvoiceProperty == "个人") {
                        params.append('Iinvoicetype', 0)

                        params.append('Itaitou', this.invoiceInfo.Name)
                    }
                    else if (this.invoiceInfo.InvoiceProperty == "公司") {
                        params.append('Iinvoicetype', 1)

                        params.append('Itaitou', this.invoiceInfo.Name)
                        params.append('Ishuihao', this.invoiceInfo.IndentityNo)
                    }
                    console.log(this.invoiceInfo.InvoiceProperty)
                }
                else {
                    params.append('Iinvoicetype', 2)

                    params.append('Itaitou', this.invoiceInfo.Name)
                    params.append('Ishuihao', this.invoiceInfo.IndentityNo)
                    params.append('Itel', this.invoiceInfo.Phone)
                    params.append('Iaddress', this.invoiceInfo.Address)
                    params.append('Ikaihuhang', this.invoiceInfo.BankName)
                    params.append('Iaccount', this.invoiceInfo.BankAccountNo)

                }
            }


            this.$http.post(api.SubmitRelaxHotelOrder(), params.toParam()).then((res) => {

                if (res.Result) {
                    this.TellUser = res.Data;
                    this.showToast();

                    var UserInfo = this.g_UserInfo;
                    UserInfo.OrderRefresh1 = true;
                    this.setG_UserInfo(UserInfo);

                    if (this.loginState) {
                        setTimeout(() => { this.$router.push({ path: '/home/order' }) }, 1300);
                    }
                    else {
                        setTimeout(() => { this.$router.push({ path: '/user/OtherUser' }) }, 1300);
                    }
                }
                else {
                    this.TellUser = res.Message;
                    this.showToast();
                }
            })
        },
        // 全日房  开始时间 如：11
        setRelaxHour(relaxHour) {
            this.relaxHour = relaxHour;

            var searchParam = this.g_searchParam;
            searchParam.relaxHour = relaxHour;
            this.setG_searchParam(searchParam);


            // this.relaxHourEND = (parseInt(this.relaxHour) + 4).toString();

            // var max = this.g_currentRoom.HourRoomEndTime;

            // if (this.relaxHourEND > max)
            //     this.relaxHourEND = max;
            // this.searchHotel();

            this.relaxHourEND = (parseInt(this.relaxHour) + this.g_currentRoom.RoomHours).toString();


        },

        gologin() {
            this.$router.push({ path: '/user/Login' });
        },




        // 开关是否有发票
        changeInvo(val) {
            if (val == true) {
                if (this.loginState)
                    this.$router.push({ path: '/search/ChooseInvoice' })
                else
                    this.invoice = true;
            }
            else {
                this.invoice = false;
            }
        },

// 保存发票
        saveInvoice() {
            this.ChooseInvoice()
            var params = new this.URLSearchParam();
            if (this.invoiceInfo.Name.trim() == '') {
                this.TellUser = '请填写抬头'
                this.showToast()
                return
            }

            if (this.invoiceInfo.InvoiceType == "增值税普通发票") {
                if (this.invoiceInfo.InvoiceProperty == "个人") {
                }
                else if (this.invoiceInfo.InvoiceProperty == "公司") {

                    if (this.invoiceInfo.IndentityNo.trim() == '') {
                        this.TellUser = '请填写税号'
                        this.showToast()
                        return
                    }
                }
            }
            else {
                if (this.invoiceInfo.IndentityNo.trim() == '') {
                    this.TellUser = '请填写税号'
                    this.showToast()
                    return
                }
                if (this.invoiceInfo.Phone.trim() == '') {
                    this.TellUser = '请填写电话'
                    this.showToast()
                    return
                }
                if (this.invoiceInfo.Address.trim() == '') {
                    this.TellUser = '请填写地址'
                    this.showToast()
                    return
                }
                if (this.invoiceInfo.BankName.trim() == '') {
                    this.TellUser = '请填写开户行'
                    this.showToast()
                    return
                }
                if (this.invoiceInfo.BankAccountNo.trim() == '') {
                    this.TellUser = '请填写账号'
                    this.showToast()
                    return
                }
            }

            this.invoice = false
        },

        //发票切换
        handleTabChange(val) {
            if (!this.canUseSp && val == 'tab2') {
                this.TellUser = '抱歉，该酒店只能开具普通发票请您谅解！'
                this.showToast()
                return
            }
            this.activeTab = val
            this.setInvoiceInfo(val, this.normalType)
        },

        //设置发票信息
        setInvoiceInfo(sTab, cType) {
            if (this.loginState) {
                if (sTab == 'tab2') {
                    this.invoiceInfo = this.ownedInvoce.special
                }
                else {
                    if (cType == 'company') {
                        this.invoiceInfo = this.ownedInvoce.company
                    }
                    else {
                        this.invoiceInfo = this.ownedInvoce.person
                    }
                }
            }
        },

        closeInvoice() {
            this.ChooseInvoice()
            //关闭发票
            this.invoice = false
            this.hasInvo = false
        },

        ChooseInvoice() {
            // 根据选择信息
            if (this.activeTab == 'tab1') {
                this.invoiceInfo.InvoiceType = '增值税普通发票'
                if (this.normalType == 'person') {
                    this.invoiceInfo.InvoiceProperty = '个人'
                }
                else {
                    this.invoiceInfo.InvoiceProperty = '公司'
                }
            }
            else {
                this.invoiceInfo.InvoiceType = '增值税专用发票'
                this.invoiceInfo.InvoiceProperty = ''
            }
        },

        // 发票部分


        //未登录用户提交订单之前验证
        noLoginValid() {
            if (this.phoneNum == '') {
                this.TellUser = '请输入手机号'
                this.showToast()
                return
            }
            if (this.imgCode == '') {
                this.TellUser = '请输入图像验证码'
                this.showToast()
                return
            }

            this.haveYZM = true;
            this.WaitTime = this.Time + "秒"
            this.timer();

            //未登录用户提交订单之前验证
            var params = new this.URLSearchParam();
            params.append('phoneNo', this.phoneNum)
            params.append('email', this.mail)
            params.append('captcha', this.imgCode)
            this.$http.post(api.getValidateCodeForNoLoginOrder(), params.toParam()).then((res) => {
                if (res.Result) {
                    this.TellUser = res.Data
                }
                else {
                    this.TellUser = res.Message

                    this.Time = 5;
                }
                this.showToast()
            })
        },
        timer() {
            if (this.Time > 0) {
                this.Time--;
                this.WaitTime = this.Time + "秒"

                setTimeout(this.timer, 1000);
            }
            else if (this.Time == 0) {
                this.haveYZM = false;
                this.Time = 29;
            }
        },



        //获取图形验证码
        getValidateCode() {
            this.TPFJM = api.getValidateCode();
        },
        open() {
            // 打开验证
            this.dialog = true
        },
        close() {
            // 关闭验证
            this.dialog = false
        },
        // 弹出层
        showToast() {
            this.toast = true
            if (this.toastTimer) clearTimeout(this.toastTimer)
            this.toastTimer = setTimeout(() => { this.toast = false }, 1000)
            if (this.TellUser == '预订失败，提交的客户信息不正确') {
                this.$http.post(api.LogOff()).then((res) => { });
                this.$store.dispatch('clearUser');
                this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1500)
            }
        },
        hideToast() {
            this.toast = false
            if (this.toastTimer) clearTimeout(this.toastTimer)
        },
        goback() {
            javascript: history.go(-1);
            // this.$router.push({ path: '/search/homeListToRelax' })
        },

       initCoupon() {
      //初始化代金券信息
        this.userVochers = {
                v1: "",
                v2: "",
                v3: ""
            };
            console.log("-------------");
            console.log(this.g_currentRoom.RoomHours)
            if(this.g_currentRoom.RoomHours==2){
              return null;
            }
            var params = new this.URLSearchParam();
            params.append("checkInDate", this.g_searchParam.startDate);
            this.$http.post(api.GetRelaxConpon(), params.toParam()).then(res => {
               if (res.Result) {
                 this.vochers=[1,2];
                 var userV = res.Message;
                for (var i in this.vochers) {
                    var vocher = this.vochers[i];
                    for (var j in userV) {
                    if (userV[j].CouponsTypeID == vocher) {
                        this.userVochers["v" + vocher] = userV[j].CouponsTypeID;
                        break;
                     }
                    }
                }
                  //设置代金券
                this.voucherState = true;
                this.voState = true;
                this.loginState = true;
                this.finallymoney=this.g_currentRoom.MemberPrice;
                } else {
                if (res.Message == "未登录") {
                    this.loginState = false;
                }
                }
            });
        },
 
       changeVocher(value) {
            this.vocher = value;
            console.log(this.vocher );
            if (value != 0) {
                this.useState.useVocher = true;
            } else {
                this.useState.useVocher = false;
          }

             if(this.g_currentRoom.RoomType==98 || this.g_currentRoom.RoomType==99)
             {
                 // 4小时
                  console.log(this.finallymoney);
                    if(this.finallymoney>0){
                        var moneybyhour=value*this.finallymoney/4
                       this.g_currentRoom.MemberPrice=this.finallymoney-moneybyhour;
                       this.g_currentRoom.MemberPrice=this.numFilter(this.g_currentRoom.MemberPrice)
                    }else
                    {
                      var moneybyhour=value*this.g_currentRoom.MemberPrice/4
                      this.g_currentRoom.MemberPrice=this.g_currentRoom.MemberPrice-moneybyhour;
                      this.g_currentRoom.MemberPrice=this.numFilter(this.g_currentRoom.MemberPrice)
                    }
             }
             else if(this.g_currentRoom.RoomType==100 || this.g_currentRoom.RoomType==101)
             {
                 // 3小时
                  console.log(this.finallymoney);
                    if(this.finallymoney>0){
                        var moneybyhour=value*this.finallymoney/3
                       this.g_currentRoom.MemberPrice=this.numFilter(this.finallymoney-moneybyhour);
                    }else
                    {
                      var moneybyhour=value*this.g_currentRoom.MemberPrice/3
                      this.g_currentRoom.MemberPrice=this.numFilter(this.g_currentRoom.MemberPrice-moneybyhour);
                    }
             }
        },

         focus(type) {
             this.useState["use" + type] = !this.useState["use" + type];
         },


        // 截取当前数据到小数点后两位
         numFilter(value) {
            const realVal = parseFloat(value).toFixed(0);
            return realVal;
            },

    },

    deactivated() {
        var orderInfo = this.g_currentOrder
        orderInfo.hotalName = this.g_currentInfo.HotelName,
        orderInfo.roomName = this.g_currentRoom.RoomName,
        orderInfo.startDate = this.g_searchParam.startDate,
        orderInfo.endDate = this.g_searchParam.endDate,
        orderInfo.days = this.day,
        orderInfo.cusName = this.cusName,
        orderInfo.phoneNum = this.phoneNum,
        orderInfo.mail = this.mail,
        orderInfo.cusNum = this.cusNum,
        orderInfo.roomNum = this.roomNum,
        orderInfo.require = this.requires,
        orderInfo.invoice = '',
        orderInfo.coupon = this.coupon,
        orderInfo.amount = this.totalPrice
        this.setG_currentOrder(orderInfo)
    },


    computed: {
        ...mapGetters([
            'g_currentInfo', 'g_searchParam', 'g_UserInfo', 'g_currentRoom', 'g_currentDiscount',
            'g_currentOrder', 'g_walletInfo'
        ]),
        day() {
            var d1 = new Date(this.g_searchParam.arriveDate)
            var d2 = new Date(this.g_searchParam.endDate)
            var s1 = d1.getTime(), s2 = d2.getTime();
            return parseInt((s2 - s1) / 1000 / (24 * 60 * 60));
        },
        arriveDateFormat() {
            return new Date(this.g_searchParam.arriveDate).Format('M月D日')
        },
        checkinMinDate() {
            //最小入住日期为当天
            return new Date()
        },
        checkinMaxDate() {
            //最大入住日期为3个月内
            return new Date().DateAdd('d', 89)//入住日期最大为3个月内
        },
        checkoutMinDate() {
            //最小离店日期比当前入住时间多一天
            return new Date(this.g_searchParam.arriveDate).DateAdd('d', 1).Format("yyyy-MM-dd")
        },
        checkoutMaxDate() {
            //最大离店日期比当前入住时间多14天
            return new Date(this.g_searchParam.arriveDate).DateAdd('d', 14).Format("yyyy-MM-dd")
        },
    },

}
</script>






<style lang="less" scoped>
@import "../../assets/theme.less";


.invoice-button {
    width: 48%;
}

.invoice-radio:first-child {
    margin: 2em 0;
    margin-right: 1em;
}

.couponList {
    label {
        color: @primaryBlack;
        font-weight: 600;
        margin: auto 1.2em;
        font-size: 0.28rem;
        width: 1.5rem;
        display: flex;
        display: -webkit-flex;
    }
}
 
.coupons {
  width: auto;
  padding: 0px 0.05rem !important;
  top: -10px;
  position: relative;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  .coupon {
    border-radius: 3px;
    min-height: 66px;
    border: 2px solid @primaryOrange;
    margin: 2px;
    display: flex;
    display: -webkit-flex;
    padding: 4px 1px !important;
    width: 2rem;
    color: @primaryBlack;
    div {
      display: inline-block !important;
      padding: 0px !important;
      text-align: center;
      margin: auto;
    }
    h3 {
      margin: 0 auto;
      font-size: 0.28rem;
    }
    p {
      margin: 0;
      font-size: 0.22rem;
    }
  }
}

.active {
    h3 {
        color: @primaryOrange;
    }
    color:@primaryOrange !important;
    border:2px solid @primaryOrange;
    position:relative;
    background: linear-gradient(135deg, @transparent 85%, @primaryOrange 10%);
}

.active:after {
    content: '√';
    color: white;
    position: absolute;
    right: 0;
    bottom: -4px;
}

.top {
    font-size: 0.28rem;
    color: @secondBlack;
    .time {
        text-align: center;
        padding: 1em;
    }
    h3 {
        color: @primaryBlack;
        font-size: 0.3rem;
        margin-left: 1em;
        padding-right: 1em;
    }
    span.num {
        color: @primaryOrange;
    }
    span.left {
        float: left;
    }
    span.left,
    span.right {
        span:first-child {
            color: @textColor;
            font-size: 0.22rem;
            margin: 5px;
        }
    }
    span.right {
        float: right;
    }
}

.greyBlock {
    width: 100%;
    height: 0.21rem;
    background-color: #F1F1F1;
}

.main {
  .room {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.84rem;
    label {
      display: inline-block;
      width: 1.5rem;
      color: @primaryBlack;
      font-size: 0.28rem;
      margin: auto 1.2em;
      font-weight: 600;
    }
    .userInput {
      color: @secondBlack;
      font-size: 0.28rem;
      border: none;
      outline: none;
      width: 4rem;
      margin: auto 0;
    }
  }
  .chechIn {
    justify-content: space-between;
    span {
      display: flex;
      margin-right: 15px;
      color: @primaryColor;
      img {
        height: 0.3rem;
        margin: auto 0.1rem;
      }
    }
  }
  .users {
    .user {
      line-height: 0.3rem;
      margin: 0 1em 1em 1em;
      padding: 0rem 0rem 0.22rem 0.4rem;
      color: #666666;
      background-color: #f9f9f9;
      border: 1px solid #e8e8e8;
      font-size: 0.3rem;

      label {
        margin-right: 0.5rem;
        font-size: 0.28rem;
      }

      .mu-text-field-hint {
        top: -1px;
      }
      .userInput {
        margin-top: 0.2rem;
        width: 3rem;
        font-size: 0.28rem;
        min-height: 20px;
        height: 20px;
        input {
          color: #666666 !important;
          font-size: 0.28rem;
        }
        .mu-text-field-content {
          padding: 0px;
        }
      }
    }
  }
}

.main {
    .mu-paper {
        div {
            display: flex;
            display: -webkit-flex;
            height: 1.2rem;
            label {
                display: inline-block;
                width: 1.5rem;
                color: @primaryBlack;
                font-size: 0.28rem;
                margin: auto 1.2em;
                font-weight: 600;
            }
            span {
                color: @secondBlack;
                font-size: 0.28rem;
                line-height: 1.2rem;
            }
            .mu-text-field {
                margin: 0px;
                .mu-text-field-content {
                    padding: 0px !important;
                }
                font-size:0.28rem;
            }
        }
        #roomNum .mu-dropDown-menu-text .mu-dropDown-menu-text {
            color: black !important;
        }
    }
    .description {
        padding: 1em;
        margin-bottom: 0.9rem;
        font-size: 0.24rem;
        color: @textColor;
        padding-bottom: 0.5rem;
    }
}
</style>




<style lang="less">
@import "../../assets/theme.less";

#LiveDate {
    .mu-text-field {
        .mu-text-field-content {
            width: 2rem; // background-color:red;
            height: 0.61rem;
            padding-top: -0.1rem;
        }
        .mu-text-field-input {
            position: absolute;
            color: transparent;
            font-size: 0.3rem;
            width: 2rem;
            z-index: 101;
        }
        .mu-text-field-hint {
            width: 2rem;
        }
    }
}

#LiveDate2 {
    .mu-dropDown-menu-text {
        height: 0.8rem; // line-height: 1rem ;
    }
    .mu-dropDown-menu-text-overflow {
        //  height:0.8rem;
        //  margin:auto auto ;
        line-height: 1rem;
    }
    .mu-dropDown-menu-icon {
        //  line-height: 1rem ;
        top: 0.25rem;
    }
}

#LiveDate3 {
    .mu-dropDown-menu-text {
        height: 0.8rem; // line-height: 1rem ;
        top: -10px;
    }
    .mu-dropDown-menu-text-overflow {
        //  height:0.8rem;
        //  margin:auto auto ;
        line-height: 1rem;
    }
    .mu-dropDown-menu-icon {
        //  line-height: 1rem ;
        //top: 0.25rem;
    }
    .mu-popover{
        width:120px;
   }
    .mu-popover.mu-menu-list{
        width:130px;
   }
}



.invoiceTab {
    background-color: red;
    .mu-tab-link {
        color: #666666;
    }
    .mu-tab-active {
        color: #27ba69;
    }
}

.mu-dialog {
    .validT {
        color: black;
        font-size: 0.32rem;
        padding: 12px 24px
    }
}

.mu-dialog-wrapper {
    .invoiceDia {
        width: 90%;
        .mu-dialog-body {
            padding: 5px;
        }
        .mu-text-field-label {
            color: #333333
        }
        .focus-state {
            .mu-text-field-label {
                color: #27ba69
            }
        }
    }
}

.mu-dropDown-menu {
    .showText {
        font-size: 0.28rem;
    }
}

.mu-dropDown-menu-line {
    background-color: transparent !important;
}

.room {
    .mu-text-field {
        width: 4rem;
    }
    .mu-text-field-content {
        padding: 0px !important;
        margin: auto 0 !important;
        display: inline-block;
        line-height: 1.2rem;
        height: auto;
    }
}

.orderDetail {
    width: 100%;
    padding-top: 10px;
    height: auto;
    .list {
        label {
            color: @primaryBlack;
            font-weight: 600;
            font-size: 0.3rem;
            display: block;
            margin: 1em 0;
            span.small {
                font-size: 0.22rem;
                color: #27BA69;
                font-weight: 500;
            }
        }
        .em {
            padding: 1em 0;
            .price {
                color: @primaryOrange;
                font-size: 0.28rem;
            }
            .right {
                color: @secondBlack;
                float: right;
            }
        }
        .pay {
            font-size: 0.3rem;
            color: @secondBlack;
            .price {
                font-size: 0.3rem;
            }
            background-color:#FCFCFC;
        }
    }
}

.roomNum {
    .mu-dropDown-menu-text {
        padding-left: 0px;
    }
    margin:auto 0px;
    position:relative;
}

.menuList {
    color: black;
}

.check {
    background: hsla(0, 0%, 100%, .9);
    position: fixed;
    bottom: 0;
    width: 7.5rem;
    background-clip: padding-box;
    z-index: 9;
    label {
        color: @textColor;
        font-size: 0.26rem;
        line-height: 1rem;
        margin-left: 1.2em;
    }
    .money {
        color: @primaryOrange;
        font-size: 0.36rem;
        .small {
            font-size: 0.26rem;
        }
    }
    .see {
        font-size: 0.22rem;
        margin-left: 1.5em;
    }
    a {
        color: white;
        float: right;
        background-color: @primaryOrange;
        height: 1rem;
        width: 2rem;
        display: flex;
        display: -webkit-flex;
        span {
            margin: auto;
        }
    }
}

.invoice {
    color: @secondBlack;
    font-size: 0.28rem !important;
    width: 5.4rem;
}
</style>







// WEBPACK FOOTER //
// makeOrderToRelax.vue?01451533